import {createReducer, on} from '@ngrx/store';
import {Region} from '../../../services/api/account/regions/region.model';
import {
  clearOrganizationRegionsState,
  loadOrganizationRegions,
  loadOrganizationRegionsFailure,
  loadOrganizationRegionsSuccess
} from './organization-account.regions.actions';


export interface State {
  record: Region[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const loadOrganizationRegionsReducer = createReducer(
  initialState,

  on(loadOrganizationRegions, (state: State, action) => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
    parameters: action
  })),
  on(loadOrganizationRegionsSuccess, (state: State, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(loadOrganizationRegionsFailure, (state: State, action) => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearOrganizationRegionsState, () => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
    parameters: null
  }))
);
